import { createRenewVisaDocumentGroupApi } from "@/api/services/main/renew-visa";
import { TGetRenewVisaDocumentListOutputDto } from "@/api/services/main/renew-visa/dtos/get-renew-visa-document-list.dto";
import { Button } from "@/components/elements/Button";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { AppRoutes } from "@/routes/config";
import { showError } from "@/utils/error";
import { toNumber } from "@/utils/number";
import { toast } from "@/utils/toast";
import { getDynamicRoute } from "@/utils/url";
import { useQueryClient } from "@tanstack/react-query";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

export type TCreateRenewVisaDocumentGroupBtnProps = {
  selectedRenewVisaDocuments: TGetRenewVisaDocumentListOutputDto[];
};

export const CreateRenewVisaDocumentGroupBtn: FC<TCreateRenewVisaDocumentGroupBtnProps> = ({ selectedRenewVisaDocuments }) => {
  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const handleCreate = async () => {
    if (selectedRenewVisaDocuments.length > 100) {
      toast.error("一括申請は100件まで可能です。");
      return;
    }

    if (selectedRenewVisaDocuments.length === 1 && selectedRenewVisaDocuments[0]?.employeeRenewVisaDocumentGroupId) {
      navigate(
        getDynamicRoute(AppRoutes.renewVisaPresent, {
          employeeRenewVisaDocumentGroupId: selectedRenewVisaDocuments[0].employeeRenewVisaDocumentGroupId,
        }),
      );
      return;
    }
    try {
      const newRenewVisaDocumentGroup = await createRenewVisaDocumentGroupApi({
        renewVisaDocumentIds: selectedRenewVisaDocuments.map((item) => toNumber(item.id)),
      });
      await queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.RENEW_VISA_DOCUMENTS.FETCH_LIST] });
      navigate(getDynamicRoute(AppRoutes.renewVisaPresent, { employeeRenewVisaDocumentGroupId: newRenewVisaDocumentGroup.data.id }));
    } catch (error) {
      showError(error);
    }
  };

  return (
    <Button size="sm" disabled={selectedRenewVisaDocuments.length === 0} onClick={() => handleCreate()}>
      選択した外国人の一括申請を編集
    </Button>
  );
};
